/*
 * Copyright (c) 2021.
 * Md Naimul Hasan
 * naim886@gmail.com
 * 01719123886
 * www.naimbd.com
 */

import React, {useEffect, useState} from 'react';
import {Link} from "react-router-dom";
import axios from "axios";
import BASEURL from "../../../Constants";
import Pagination from "react-js-pagination";
import {Modal} from "react-bootstrap";
import Select from "react-select";
import {toast, ToastContainer} from "react-toastify";
import loader from "../../../Assets/image/loader/ripple.svg";

const Schedule = () => {

    const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
    const [activePage, setActivePage] = useState(1)
    const [itemsCountPerPage, setItemsCountPerPage] = useState(0)
    const [totalItemsCount, setTotalItemsCount] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [errMsg, setErrMsg] = useState([])


    const [schedule, setSchedule] = useState([])
    const [filterData, setFilterData] = useState(null)

    const handleAssignModal = (id) => {
        getUserPreferredTime(id)
        setIsAssignModalOpen(true)
        setInput(prev => ({...prev, appointment_id: id}))
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getSchedule = (pageNumber = null) => {
        setIsLoading(true)
        setActivePage(pageNumber)
        axios.get(BASEURL + '/api/dashboard/get-schedule?page=' + pageNumber + '&filter=' + filterData).then(res => {
            setSchedule(res.data.data)
            setItemsCountPerPage(parseInt(res.data.meta.per_page))
            setTotalItemsCount(res.data.meta.total)
            setActivePage(res.data.meta.current_page)
            setIsLoading(false)
        })
    }
    const handleDateInput = (e) => {
        setFilterData(e.target.value)
    }
    const handleScheduleList = (data) => {
        setFilterData(data)
    }
    useEffect(() => {
        getSchedule()
    }, [filterData])

    useEffect(() => {
        getSchedule()
        getShifts()
        getTruckList()
    }, [])

    const [userPreferredTime, setUserPreferredTime] = useState('')
    const getUserPreferredTime = (id) => {
        axios.get(BASEURL + '/api/dashboard/get-user-preferred-time/' + id).then(res => {
            setUserPreferredTime(res.data)
        })
    }

    const [truckList, setTruckList] = useState([])
    const getTruckList = () => {
        axios.get(BASEURL + '/api/dashboard/get_truck_list_for_select').then(res => {
            setTruckList(res.data)
        })
    }
    const [input, setInput] = useState({})
    const handleSelect = (selectedOption, e) => {
        setInput(prev => ({...prev, [e.name]: selectedOption.value}))
    }
    const [shift, setShift] = useState([])
    const getShifts = () => {
        axios.get(BASEURL + '/api/dashboard/get-shift-for-select').then(res => {
            setShift(res.data)
        })
    }
    const handleInput = (e) => {
        setInput(prev => ({...prev, [e.target.name]: e.target.value}))
    }
    const updateSchedule = () => {
        axios.post(BASEURL + '/api/dashboard/schedule', input).then(res => {
            setErrMsg([])
            if (res.data.msg == 'Truck Already Scheduled') {
                toast.warn(res.data.msg);
            } else {
                setIsAssignModalOpen(false)
                toast.success(res.data.msg);
                getSchedule()
            }
        }).catch(function (errors) {
            if (errors.response.status == 422) {
                setErrMsg([])
                setErrMsg(errors.response.data.errors)
            }
        })
    }

    return (
        <main>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <div className="container-fluid px-4">
                <h1 className="mt-4">Schedule Details</h1>
                <ol className="breadcrumb mb-4">
                    <li className="breadcrumb-item"><Link to={'/'}>Dashboard</Link></li>
                    <li className="breadcrumb-item active">Schedule Details</li>
                </ol>
                <div className="my-card">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-7">
                                    <button onClick={() => handleScheduleList('all')}
                                            className={'btn btn-success btn-sm mb-2'}>All Schedule
                                    </button>
                                    <button onClick={() => handleScheduleList('today')}
                                            className={'btn btn-success btn-sm mb-2 ms-2'}>Today's Schedule
                                    </button>
                                    <button onClick={() => handleScheduleList('next')}
                                            className={'btn btn-success btn-sm mb-2 ms-2'}>Next Day's Schedule
                                    </button>
                                </div>

                                <div className="col-md-5">
                                    <div className="row">
                                        <div className="col-5 text-end">
                                            <p className={'mt-1'}>Search By Date :</p>
                                        </div>
                                        <div className="col-7">
                                            <input
                                                type={'date'}
                                                name={'date'}
                                                onChange={handleDateInput}
                                                className={'form-control form-control-sm'}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <table className={'table table-hover table-bordered'}>
                                <thead>
                                <tr>
                                    <th>SL</th>
                                    <th>Order No</th>
                                    <th>Truck Number</th>
                                    <th>Schedule Date</th>
                                    <th>Schedule Shift</th>
                                    <th>Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                {schedule.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item.order_no}</td>
                                        <td>{item.truck_no}</td>
                                        <td>{item.date}</td>
                                        <td>{item.shift}</td>
                                        <td>
                                            <button onClick={() => handleAssignModal(item.order_no)}
                                                    className={'btn btn-success btn-sm'}><i
                                                className={'fas fa-edit'}/> Update Schedule
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                            {Object.keys(schedule).length == 0  && !isLoading?
                                <div className="loader">
                                <h6 className={'text-danger text-center'}>No Data Found</h6>
                                </div>:null
                            }
                            {isLoading ?
                                <div className="loader">
                                    <img src={loader} alt={'Loader'}/>
                                </div> : null
                            }
                            {totalItemsCount > 20 ?
                                <nav aria-label="Page navigation example">
                                    <Pagination
                                        activePage={activePage}
                                        itemsCountPerPage={itemsCountPerPage}
                                        totalItemsCount={totalItemsCount}
                                        // pageRangeDisplayed={5}
                                        onChange={getSchedule}
                                        nextPageText="Next"
                                        prevPageText="Previous"
                                        firstPageText="First"
                                        lastPageText="Last"
                                        itemClass="page-item"
                                        linkClass="page-link"
                                    />
                                </nav> : null
                            }
                        </div>
                    </div>
                </div>
            </div>


            <Modal
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={isAssignModalOpen}
                onHide={() => setIsAssignModalOpen(false)}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <span>Assign Order</span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-12">
                            <h5 className={'text-success mb-3'}>User Preferred Time : {userPreferredTime}</h5>
                        </div>
                        <div className="col-md-6 my-2">
                            <label>
                                Select Truck
                                <Select
                                    options={truckList}
                                    placeholder={'Select Option'}
                                    onChange={handleSelect}
                                    name={'truck_id'}
                                />
                                {Object.entries(errMsg).map(([key, val]) => (
                                    <small
                                        className="text-danger validation-error-message"
                                        key={key}>{key == 'truck_id' ? val : ''}
                                    </small>
                                ))}
                            </label>
                        </div>
                        <div className="col-md-6 my-2">
                            <label>
                                Select Shift
                                <Select
                                    options={shift}
                                    placeholder={'Select Option'}
                                    onChange={handleSelect}
                                    name={'shift_id'}
                                />
                                {Object.entries(errMsg).map(([key, val]) => (
                                    <small
                                        className="text-danger validation-error-message"
                                        key={key}>{key == 'shift_id' ? val : ''}
                                    </small>
                                ))}
                            </label>
                        </div>
                        <div className="col-md-12 my-2">
                            <label>
                                Select Date Time
                                <input
                                    placeholder={'Select Time and Date'}
                                    onChange={handleInput}
                                    name={'schedule_time'}
                                    type={'datetime-local'}
                                    className={'form-control'}
                                />
                                {Object.entries(errMsg).map(([key, val]) => (
                                    <small
                                        className="text-danger validation-error-message"
                                        key={key}>{key == 'schedule_time' ? val : ''}
                                    </small>
                                ))}
                            </label>
                        </div>
                        <div className="col-md-12 my-2">
                            <div className="d-grid">
                                <button className={'btn btn-success'} onClick={updateSchedule}>Assign Truck and Time
                                </button>
                            </div>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
        </main>
    );
};

export default Schedule;
